<template>
  <ZigzagServiceLayout
    mainTitle="PRP e Microagulhamento: Regeneração Natural"
    mainDescription="Nossas terapias de PRP usam os fatores de crescimento do seu próprio corpo para estimular a cicatrização natural e a regeneração da pele com o mínimo de repouso."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PRPMicroneedlingFacialContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ESTÉTICA',
          title: 'Rejuvenescimento da Pele',
          subtitle: 'Estimula o colágeno para uma textura mais suave.',
          paragraphs: [
            "Aproveitamos o poder dos fatores de crescimento do seu corpo para transformar a sua pele.",
            "A terapia com PRP reduz a pigmentação, suaviza as cicatrizes de acne e rejuvenesce a textura geral, garantindo um visual jovem."
          ],
          list: [
            "Estimula a produção de colágeno",
            "Apoia uma textura de pele mais suave",
            "Reduz a pigmentação e cicatrizes de acne",
            "Pele visivelmente mais radiante"
          ],
          image: '/images/services/prp-skin.png'
        },
        {
          label: 'RESTAURAÇÃO',
          title: 'PRP para Restauração Capilar',
          subtitle: 'Fortalece os folículos e promove novos crescimentos.',
          paragraphs: [
            "O PRP é um avanço na restauração capilar não cirúrgica, combatendo eficazmente a queda de cabelo.",
            "Ao focar nos folículos capilares com plaquetas concentradas, reduz-se a queda e estimula-se um crescimento mais forte."
          ],
          list: [
            "Abordagem não cirúrgica para a queda",
            "Fortalece os folículos desde a raiz",
            "Reduz a queda de cabelo significativamente",
            "Promove o crescimento natural e mais espesso"
          ],
          image: '/images/services/prp-hair.png'
        },
        {
          label: 'BEM-ESTAR E RECUPERAÇÃO',
          title: 'Alívio Articular e Visão Geral',
          subtitle: 'Cura natural para artrite, tendinite e lesões.',
          paragraphs: [
            "O PRP é uma ferramenta poderosa para acelerar sua recuperação. Ele reduz a inflamação, proporcionando alívio contínuo.",
            "O processo é simples e envolve rápido tempo de cura, ajudando a restaurar o equilíbrio e a confiança com segurança."
          ],
          list: [
            "Reduz a inflamação e a dor articular",
            "Auxilia na recuperação da artrite",
            "Processo rápido: Retire, Separação, Aplicação",
            "Pronta recuperação com inchaço leve"
          ],
          image: '/images/services/prp-wellness.png'
        }
      ]
    };
  }
};
</script>
